import getCbisHmac from '../../utils/cbisHmac';
import { ReduxState } from '../../types';

const auth = (state: ReduxState) => {
  const appId = process.env.AXP_READ_SUPPLIER_EMAIL_APP_ID as string;
  const secret = process.env.AXP_READ_SUPPLIER_EMAIL_SECRET as string;
  const version = state.getIn(['config', 'cbisVersion']) as string;
  const url = state.getIn(['config', 'cbisUrl']);
  const timestamp = Date.now();
  const hmac = getCbisHmac(appId, secret, version, timestamp);
  return {
    appId,
    version,
    url,
    timestamp,
    hmac,
  };
};

const cbisAuthorization = {
  fetch(id: string, action: string, state: ReduxState) {
    const { appId, version, url, timestamp, hmac } = auth(state);
    const scopeId = id === '' ? 'ReadSupplierPaymentCommercialPaymentGatewayEmail.v1' : id;
    return {
      url,
      opts: {
        method: 'POST',
        headers: {
          'X-Auth-AppID': appId,
          'X-Auth-Timestamp': timestamp,
          'X-Auth-Version': version,
          'X-Auth-Signature': hmac,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ scope: [`function:/${scopeId}`] }),
      },
    };
  },
};
export default cbisAuthorization;
